import React from 'react'

import { tw } from '~/lib/utils'

type Option<T> = {
  value: T
  label: string
}

export type Options<T> = Array<Option<T>>

type RadioProps<T extends string> = {
  disabled?: boolean
  className?: string
  label?: string
  name: string
  onSelect: (value: T) => void
  optionClassName?: string
  options: Options<T>
  value: T
}

const RadioGroup = <T extends string>({
  className,
  label,
  name,
  onSelect,
  optionClassName,
  options,
  value,
  disabled,
}: RadioProps<T>): JSX.Element => {
  return (
    <div className={tw('flex justify-between', className)}>
      {label && <label>{label}</label>}
      {options.map((item, idx) => {
        return (
          <div
            className={tw(
              'flex space-x-2 align-middle text-body-m accent-blue-500',
              optionClassName,
              disabled ? 'cursor-not-allowed text-disabled' : ''
            )}
            key={`${name}-${idx}`}
          >
            <input
              checked={value === item.value}
              data-testid={item.value}
              disabled={disabled}
              id={item.value}
              name={name}
              type="radio"
              onChange={() => onSelect(item.value)}
            />
            <label htmlFor={item.value}>{item.label}</label>
          </div>
        )
      })}
    </div>
  )
}

export default RadioGroup
